export function header() {
    let $doc = $(document);
    let $win = $(window);
    // let $body = $("body");
    let $header = $(".header");
    let menuBtnSelector = ".menu-opener";
    let backBtnSelector = ".back-btn";
    let $megaMenuItems = $(".has-menu");
    let $mobileButtons = $(".mobile-buttons");
    let $navBlock = $header.find(".nav-outer");
    let $dropdown = $(".megamenu-item");
    let eventType = "click";

    if ($win.width() < 1200) {
        $header.addClass("mob-view");
    } else {
        eventType = "mouseenter";

        if ($win.scrollTop() > 0) {
            $header.addClass("colored");
        }

        $megaMenuItems.on("mouseleave", function() {
            $megaMenuItems.removeClass("open");
            $navBlock.removeClass("dropdown-is-open");
            $header.removeClass("show");
        });
    }

    $megaMenuItems.on(eventType, "> a", function(e) {
        e.preventDefault();
        $megaMenuItems.removeClass("open");
        $(this).parent().addClass("open");
        $navBlock.addClass("dropdown-is-open");

        if ($win.width() < 1200) {
            $mobileButtons.addClass("show-back-btn");
        } else {
            $header.addClass("show");
        }
    })

    $doc.on("click", menuBtnSelector, function() {
        $header.toggleClass("show-menu");
        $megaMenuItems.removeClass("open");
        $navBlock.removeClass("dropdown-is-open");
        $mobileButtons.removeClass("show-back-btn");
    });

    $doc.on("click", backBtnSelector, function() {
        $megaMenuItems.removeClass("open");
        $navBlock.removeClass("dropdown-is-open");
        $mobileButtons.removeClass("show-back-btn");
    });

    $win.on("resize", function() {

        if ($win.width() >= 1200) {
            $header.removeClass("mob-view");
            $mobileButtons.removeClass("show-back-btn");
            $navBlock.removeClass("dropdown-is-open");
            $header.removeClass("show-menu");
            $megaMenuItems.removeClass("open");
            eventType = "mouseenter";
        } else {
            $header.addClass("mob-view");
            eventType = "click";
        }
    });

    $win.on("scroll", function () {

        if ($win.width() >= 1200) {
            if ($win.scrollTop() > 0) {
                $header.addClass("colored");
            } else {
                $header.removeClass("colored");
            }
        }
    });

    $win.on("wheel", function (e){

        if ($win.width() >= 1200) {
            if (e.originalEvent.wheelDelta >= 8 && e.originalEvent.wheelDelta > 0){
                $header.removeClass("hide");
            } else if (e.originalEvent.wheelDelta < 0 && e.originalEvent.wheelDelta <= -7) {
                $header.addClass("hide");
            }
        }
    });

    $doc.ready(function () {
        let anchor = window.location.hash;
        if (anchor && $(anchor).length) {
            $('html, body').animate({
                scrollTop: $(anchor).offset().top - 50
            }, 1000);
        }
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/header.js